import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, roundToTwoDecimals, callApi } from "../Helpers";
import {
  STR_BUY_NOW,
  STR_AVAILABLE_ROOMS,
  STR_HOTEL_IS_FULL,
  STR_PURCHASE_SUBSCRIPTION_PACKAGE,
  STR_SUBSCRIPTION_HAS_EXPIRED,
  STR_NO_ROOMS_AVAILABLE,
} from "../Strings";
import { MdCall, MdMessage, MdWhatsapp } from "react-icons/md";
import { GiPathDistance } from "react-icons/gi";
import { RiPinDistanceLine } from "react-icons/ri";

export default function View({ data, unClickable = false }) {
  const appContext = useContext(AppContext);

  const [rooms, setRooms] = useState(null);

  async function getRooms() {
    await callApi("get-hotel-rooms", { hotelId: data.id }).then((response) => {
      if (response.status === 1) {
        setRooms(response.data);
      }
    });
  }

  useEffect(() => {
    getRooms();
  }, [data.id]);

  const availableRoomsCount = Number(data.availableRoomsCount || 0);

  const totalRoomsCount = Number(data.totalRoomsCount || 0);

  const startingPrice = Number(data.startingPrice);

  const hotelIsFull = totalRoomsCount > 0 && availableRoomsCount === 0;

  /* Place states here */

  function view() {
    if (!unClickable) {
      appContext.navTo({
        item: "view",
        subItem: "hotel",
        extraItem: data.id,
      });
    }
  }

  return (
    <div
      className=""
      onClick={view}
      style={{
        width: "100%",
        height: "300px",
        padding: "0",
        borderRadius: "20px",
        overflow: "hidden",
        position: "relative",
        marginBottom: "10px",
        backgroundImage: `url(${CDN_URL + data.photo1})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
        }}
      >
        {rooms ? (
          hotelIsFull ? (
            <span className="badge bg-dark">
              {STR_HOTEL_IS_FULL[appContext.language]}
            </span>
          ) : totalRoomsCount === 0 ? (
            <span className="badge bg-dark">
              {STR_NO_ROOMS_AVAILABLE[appContext.language]}
            </span>
          ) : (
            <span className="badge bg-secondary">
              {availableRoomsCount} {STR_AVAILABLE_ROOMS[appContext.language]}
            </span>
          )
        ) : null}
      </div>
      <div
        style={{
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(to bottom, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 1) 100%)",
        }}
      >
        <h6
          style={{
            fontSize: "32px",
            position: "absolute",
            bottom: "0",
            left: "0",
            padding: "10px",
          }}
          className="text-light"
        >
          {data.name}

          {data.distance !== null ? (
            <>
              <br />
              <span
                style={{
                  fontSize: "16px",
                  display: "",
                }}
                className="font-bold badge bg-surface"
              >
                <RiPinDistanceLine size={20} />{" "}
                {roundToTwoDecimals(data.distance)} Km
              </span>
            </>
          ) : (
            ""
          )}
        </h6>

        <h6
          style={{
            fontSize: "32px",
            position: "absolute",
            bottom: "0",
            right: "0",
            padding: "10px",
          }}
          className="text-light"
        >

          {startingPrice !== null && startingPrice > 0 ? (
            <>
              <br />
              <span
                style={{
                  fontSize: "16px",
                  display: "",
                }}
                className="font-bold badge bg-surface"
              >
                TZS {startingPrice} +
              </span>
            </>
          ) : (
            ""
          )}
        </h6>
      </div>
    </div>
  );
}
